module.exports = "/assets/24ac6aa9d1d88107a358bc828e493090.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VK.png
// module id = 1929
// module chunks = 0